import { fontStyles } from '@/styles/typography';

import { SmallDotIcon } from '@/ui/Icons/SmallDotIcon';

import { TokenResult } from '@/utils/0x/token-registry.types';
import { isTokenResultNativeAsset } from '@/utils/multichain';

import TokenProfileContractAddress from '../TokenProfileContractAddress';

interface ChainAddressInfoProps {
  activeToken: TokenResult;
}

export const ChainAddressInfo = ({ activeToken }: ChainAddressInfoProps) => {
  const showTokenAddress = !isTokenResultNativeAsset(activeToken);

  return (
    <div
      className={fontStyles({
        variant: 'BODY_MD',
        class: 'flex items-center flex-row w-full ml-1 text-token-gray-800',
      })}
    >
      <span>{activeToken.chainName}</span>
      {showTokenAddress && (
        <>
          <SmallDotIcon className="text-token-gray-500 ml-2 mr-1" />
          <TokenProfileContractAddress token={activeToken} />
        </>
      )}
    </div>
  );
};
